export default __webpack_public_path__ + "static/media/s1.38355521.png";